import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col, FormGroup, Label, Input, Table } from "reactstrap";
import { Formik } from "formik";
import { useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { NumberWithCommas } from "../share/NumberWithCommas";

export function BorrowFollowEightComponent() {
    const [searchParams] = useSearchParams(); //searchParams.get('req')
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("userData"))
    const [dataBorrowEight, setBorrowEight] = useState([]);
    const [sumTdPayment, setSumTdPayment] = useState(0);
    const [dataTdPaymentTest, setDataTdPaymentTest] = useState({});
    const [dataTdPaymentTrain, setDataTdPaymentTrain] = useState({});
    const [dataTdTrainTests, setDataTdTrainTests] = useState([]);

    useEffect(() => {
        GetBorrowEight()
    }, [])
    async function GetBorrowEight() {
        try {
            let postData = new FormData();
            postData.append("borrowId", searchParams.get('req'))
            const res = await fetch("/api/Borrow/getBorrowEight", {
                method: "POST",
                body: postData
            })
            const data = await res.json()
            if (!data.dataenum.tdTrainTests.length) {
                Swal.fire({
                    icon: "info",
                    title: "ผู้ขอกู้รายนี้ ได้ทำการฝึกอบรม/ทดสอบเสร็จสิ้นเรียบร้อยแล้ว",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate(`/borrowing/`)
                    }
                });
            } else {
                setBorrowEight(data.dataenum);
                /*console.log(data.dataenum);*/

                let sumtdPayments = 0;
                data.dataenum.tdPayments.map((row) => {
                    //console.log(row.id)
                    // console.log(row.ampere)
                    sumtdPayments = sumtdPayments + row.amountApprove

                })
                setSumTdPayment(sumtdPayments)

                setDataTdPaymentTrain(data.dataenum.tdPayments.filter(
                    (type) => type.paymentTypeId === 1
                ))

                setDataTdPaymentTest(data.dataenum.tdPayments.filter(
                    (type) => type.paymentTypeId === 2
                ))

                setDataTdTrainTests(data.dataenum.tdTrainTests)
                console.log("dataatasdr", data.dataenum.tdTrainTests)
            }

        } catch (err) {
            console.log(err);
        }
    }



    // console.log("dataEight", dataBorrowEight)
    const fromInitialValues = {
        RegisterId: user.registerId,
        BorrowId: searchParams.get('req'),
        ItemFollowSelected: "",
        FollowType: "",
        ContactMatch: "",
        Issue: "",
        Remark: "",
        ImagePath: "",
        VideoPath: "",
        FollowOther: "",

    }

    //.zip .rar
    const zipCT = ["application/zip", "application/octet-stream", "application/x-zip-compressed", "multipart/x-zip", "application/vnd.rar", "application/x-rar-compressed", "application/octet-stream"]

    const validateSchema = Yup.object().shape({
        ItemFollowSelected: Yup.string().required("*จำเป็น"),
        // FollowType: Yup.string().required("*จำเป็น"),
        ContactMatch: Yup.string().required("*จำเป็น"),
        Issue: Yup.string(),
        Remark: Yup.string(),
        ImagePath: Yup.mixed().when("FollowType", {
            is: "3_31",
            then: Yup.mixed()
                .test('fileFormat', 'เฉพาะไฟล์ชนิด .zip ฟรือ .rar', (value) => {
                    // console.log(value)
                    return value && zipCT.includes(value.type);
                })
        }),
        VideoPath: Yup.mixed().when("FollowType", {
            is: "4_41",
            then: Yup.mixed()
                .test('fileFormat', 'เฉพาะไฟล์ชนิด .zip ฟรือ .rar', (value) => {
                    // console.log(value)
                    return value && zipCT.includes(value.type);
                })
        }),
        FollowOther: Yup.string().when("FollowType", {
            is: "5_51",
            then: Yup.string().required("*จำเป็น"),
        }),

    });

    const onSubmit = async (values, actions) => {
        // console.log("onSubmit")
        // console.log(values)

        const formData = new FormData();
        Object.entries(values).forEach(([key, value]) => {
            formData.append(key, value);

        });

        try {
            let res = await fetch("/api/Borrow/saveFromBorrowEight", {
                method: "POST",
                body: formData

            });

            let resJson = await res.json();
            // console.log(resJson)
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate(`/borrowing/`)
                    }
                });

            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }

        } catch (e) {
            console.log(e)
        }
    }

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={fromInitialValues}
            validationSchema={validateSchema}
            enableReinitialize
        >
            {({ values, errors, touched, setFieldValue, setValues, handleBlur, handleChange, handleSubmit, submitForm }) => {

                const followSubmit = () => {

                    // console.log(errors)
                    submitForm()


                }
                // console.log("checkpoint", values)
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        <div className="form-border">
                            <Form className="p-5 mb-4">
                                {/*เลือกประเภท*/}
                                {/* <Label className="me-4 text-dark">ประเภทผู้กู้ยืมเงิน</Label>
                                {dataBorrowEight?.borrowTypeE?.map((dataType, i) =>
                                    <div className="mx-3">
                                        <Label>{dataType.typeName}</Label>
                                    </div>
                                )} */}
                                <FormGroup>
                                    <Label>
                                        จำนวนเงินกู้ตามสัญญา
                                    </Label>
                                    <Col>
                                        <p className="text-center rounded-pill border py-1 input-color" >
                                            {NumberWithCommas(sumTdPayment)} บาท
                                        </p>
                                    </Col>
                                </FormGroup>

                                <div className="p-3">
                                    <FormGroup>
                                        <Label>ฝึกอบรม</Label>
                                        <Row className="mx-3">
                                            <Label sm={1}> จำนวน </Label>
                                            <Col className="pt-2 mx-3 text-center input-color" sm={1}>
                                                {dataTdPaymentTrain[0]?.course ? dataTdPaymentTrain[0].course : "-"}
                                            </Col>
                                            <Label sm={2}>หลักสูตร
                                            </Label>
                                            <Label sm={1}>จำนวน
                                            </Label>
                                            <Col className="pt-2 mx-3 text-center input-color" sm={2}>
                                                {dataTdPaymentTrain[0]?.personTotal ? dataTdPaymentTrain[0].personTotal : "-"}
                                            </Col>
                                            <Label sm={2}>คน</Label>
                                        </Row>
                                    </FormGroup>
                                </div>
                                <div className="px-3">
                                    <FormGroup>
                                        <Label>ทดสอบมาตรฐานฝีมือแรงงาน</Label>
                                        <Row className="mx-3">
                                            <Label sm={1}>จำนวน </Label>
                                            <Col className="pt-2 mx-3 text-center input-color" sm={1}>
                                                {dataTdPaymentTest[0]?.course ? dataTdPaymentTest[0].course : "-"}
                                            </Col>
                                            <Label sm={2}> สาขาอาชีพ </Label>
                                            <Label sm={1}>จำนวน</Label>
                                            <Col className="pt-2 mx-3 text-center input-color" sm={2}>
                                                {dataTdPaymentTest[0]?.personTotal ? dataTdPaymentTest[0].personTotal : "-"}
                                            </Col>
                                            <Label sm={2}>คน</Label>
                                        </Row>
                                    </FormGroup>
                                </div>
                                <Label className="pt-3 input-color">การเลื่อนเวลาการฝึกอบรม/ทดสอบฯ</Label>
                                <div className="pt-2">
                                    <div className="mx-3 input-color">
                                        {dataBorrowEight?.isPostpone ? <Label>เลื่อนเวลา</Label> : <Label>ไม่เลื่อนเวลา</Label>}
                                    </div>
                                </div>
                                {dataBorrowEight?.isPostpone && <>
                                    <div className="p-3">
                                        <FormGroup>
                                            <Label>ฝึกอบรม</Label>
                                            <Row className="mx-3">
                                                <Label sm={1}> จำนวน </Label>
                                                <Col className="pt-2 mx-3 text-center" sm={1}>
                                                    {dataBorrowEight?.trainNewClasses}
                                                </Col>
                                                <Label sm={2}>หลักสูตร
                                                </Label>
                                            </Row>
                                        </FormGroup>
                                    </div>
                                    <div className="px-3">
                                        <FormGroup>
                                            <Label>ทดสอบมาตรฐานฝีมือแรงงาน</Label>
                                            <Row className="mx-3">
                                                <Label sm={1}>จำนวน </Label>
                                                <Col className="pt-2 mx-3 text-center" sm={1}>
                                                    {dataBorrowEight?.testNew}
                                                </Col>
                                                <Label sm={2}> หลักสูตร </Label>
                                            </Row>
                                        </FormGroup>

                                    </div>
                                </>
                                }

                                {/* ------------------------------------------ */}
                                <Label className="pt-3 input-color">
                                    การติดตามการทดสอบมาตรฐานฝีมือแรงงานและทดสอบมาตรฐานฝีมือแรงงาน
                                    {errors.ItemFollowSelected ? (
                                        <span className="text-left text-danger mx-1">
                                            {errors.ItemFollowSelected}
                                        </span>
                                    ) : null}
                                </Label>

                                <FormGroup>

                                    {dataTdTrainTests?.map((item, i) =>
                                        <FormGroup check>
                                            <Input
                                                name="ItemFollowSelected"
                                                id="ItemFollowSelected"
                                                value={item.paymentTypeId + '_' + item.itemId}
                                                type="radio"
                                                className="mx-1 cus-type"
                                                // onClick={HandleCheckedItemFollow}
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                            />
                                            {' '}
                                            <Label check>
                                                <p>{item.itemName} จำนวน {item.personTotal} คน</p>
                                                <p> ตั้งแต่ {item.startDate} ถึง {item.endDate}</p>
                                            </Label>
                                        </FormGroup>

                                    )}

                                </FormGroup>

                                {/* ------------------------------------------ */}

                                <Label className="me-4 pt-3 input-color"
                                    for=""
                                    name="">
                                    วิธีการติดตามการฝึกอบรมฝีมือแรงงานหรือทดสอบมาตรฐานฝีมือแรงงาน
                                    {errors.FollowType ? (
                                        <span className="text-left text-danger mx-1">
                                            {errors.FollowType}
                                        </span>
                                    ) : null}
                                </Label>
                                <div className="px-3">
                                    <div className="">
                                        <FormGroup>
                                            <Input
                                                type="checkbox"
                                                className="mx-2 cus-type"
                                                value="1_0"
                                                name="FollowType"
                                                id="FollowType"
                                                // onClick={HandleCheckedFollowType}
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                            />
                                            <Label>เข้าตรวจเยี่ยมและให้คำปรึกษาแนะนำระหว่างดำเนินการ</Label>
                                        </FormGroup>
                                    </div>
                                    <div className="mx-3">
                                        <FormGroup>
                                            <Label>ผ่านโซเชียลมีเดีย</Label>
                                        </FormGroup>
                                    </div>
                                    <div className="mx-3">
                                        <FormGroup>
                                            <Input
                                                type="checkbox"
                                                className="mx-2 cus-type"
                                                value="2_21"
                                                name="FollowType"
                                                id="FollowType"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                            />
                                            <Label>เฟซบุ๊กไลฟ์</Label>

                                        </FormGroup>
                                    </div>
                                    <div className="mx-3">
                                        <FormGroup>
                                            <Input
                                                type="checkbox"
                                                className="mx-2 cus-type"
                                                value="2_22"
                                                name="FollowType"
                                                id="FollowType"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                            />
                                            <Label>ยูทูป</Label>

                                        </FormGroup>
                                    </div>
                                    <div className="mx-3">
                                        <FormGroup>
                                            <Input
                                                type="checkbox"
                                                className="mx-2 cus-type"
                                                value="2_23"
                                                name="FollowType"
                                                id="FollowType"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                            />
                                            <Label>สไกป์</Label>

                                        </FormGroup>
                                    </div>
                                    <div className="m-0 ">
                                        <FormGroup>
                                            <Input
                                                type="checkbox"
                                                className="mx-2 cus-type"
                                                value="3_31"
                                                name="FollowType"
                                                id="FollowType"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                            />
                                            <Label>ภาพถ่ายกิจกรรมการฝึกอบรมหรือทดสอบมาตรฐานฝีมือแรงงาน</Label>
                                        </FormGroup>
                                    </div>
                                    <FormGroup className="mx-3">
                                        <Label>กรุณาแนบไฟล์รูปภาพ</Label>
                                        <Input
                                            id="ImagePath"
                                            name="ImagePath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onChange={(e) => {
                                                setFieldValue("ImagePath", e.target.files[0])
                                            }}
                                            onBlur={handleBlur}
                                            accept="application/zip,application/vnd.rar"
                                        />
                                        {errors.ImagePath ? (
                                            <span className="text-left text-danger mx-1">
                                                {errors.ImagePath}
                                            </span>
                                        ) : null}
                                    </FormGroup>
                                    <div className="m-0 ">
                                        <FormGroup>
                                            <Input
                                                type="checkbox"
                                                className="mx-2 cus-type"
                                                value="4_41"
                                                name="FollowType"
                                                id="FollowType"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                            />
                                            <Label>วิดิโอกิจกรรมการฝึกอบรมหรือทดสอบฯ</Label>

                                        </FormGroup>
                                    </div>
                                    <FormGroup className="mx-3">
                                        <Label>กรุณาแนบไฟล์วิดีโอกิจกรรม</Label>
                                        <Input
                                            id="VideoPath"
                                            name="VideoPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onChange={(e) => {
                                                //console.log(e.target.files[0])
                                                setFieldValue("ImagePath", e.target.files[0])
                                            }}
                                            onBlur={handleBlur}
                                            accept="application/zip,application/vnd.rar"
                                        />
                                        {errors.VideoPath ? (
                                            <span className="text-left text-danger mx-1">
                                                {errors.VideoPath}
                                            </span>
                                        ) : null}
                                    </FormGroup>
                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className="mx-2 cus-type"
                                            value="5_51"
                                            name="FollowType"
                                            id="FollowType"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                        />
                                        <Label>วิธีอื่นๆ (ถ้ามี โปรดระบุ)</Label>
                                        <FormGroup className="mx-3">
                                            <Input
                                                id="FollowOther"
                                                name="FollowOther"
                                                type="text"
                                                value={values.FollowOther}
                                                className="rounded-pill text-center input-color"
                                            />
                                            {errors.FollowOther ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.FollowOther}
                                                </span>
                                            ) : null}
                                        </FormGroup>

                                    </FormGroup>
                                </div>
                                <Label className="input-color"
                                    for=""
                                    name="">
                                    บันทึกความเห็นจากการติดตามการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
                                    {errors.ContactMatch ? (
                                        <span className="text-left text-danger mx-1">
                                            {errors.ContactMatch}
                                        </span>
                                    ) : null}
                                </Label>
                                <div className="mx-3">
                                    <Label className=""
                                        for=""
                                        name="">
                                        ดำเนินการฝึกอบรมหรือทดสอบฯ

                                    </Label>
                                    <div className="pt-3">
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                className="mx-2 cus-type"
                                                value="1"
                                                name="ContactMatch"
                                                id="ContactMatch"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                            />
                                            <Label>ตรงตามสัญญากู้ยืมเงิน</Label>
                                        </FormGroup>
                                    </div>
                                    <div className="">
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                className="mx-2 cus-type"
                                                value="0"
                                                name="ContactMatch"
                                                id="ContactMatch"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                            />
                                            <Label>ไม่ตรงตามสัญญากู้ยืมเงิน</Label>
                                        </FormGroup>
                                    </div>
                                </div >
                                <Row className="px-2">
                                    <Label className=""
                                        for=""
                                        name="">
                                        ปัญหาที่พบ

                                    </Label>
                                    <Col sm={12}>
                                        <Input
                                            id="Issue"
                                            name="Issue"
                                            type="text"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.Issue}
                                        />
                                    </Col>
                                </Row>
                                <Row className="pt-2 px-2">
                                    <Label className=""
                                        for=""
                                        name="">
                                        ข้อเสนอ

                                    </Label>
                                    <Col sm={12}>
                                        <Input
                                            id="Remark"
                                            name="Remark"
                                            type="text"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.Remark}
                                        />
                                    </Col>
                                </Row>

                                <div className="text-center pt-3">
                                    <button
                                        className="submit-btn w-50"
                                        type="button"
                                        onClick={() => followSubmit()}
                                    >

                                        บันทึกข้อมูล
                                    </button>
                                </div>
                            </Form>
                        </div>
                        {/* )} */}
                    </Container>
                );
            }}
        </Formik>
    );

}

